<template>
  <div class='content-page atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="searchParam" ref="searchForm" :rules="rules" class="atb-input" :show-message="false" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="searchParam.superiorNo" placeholder="输入工号或姓名查询"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <el-input v-model="searchParam.wkName" placeholder="姓名" clearable></el-input>
            </el-form-item>

            <el-form-item label="年份" prop="year">
              <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
            </el-form-item>
          <!-- </div>
          <div class="query-operation"> -->
            <el-form-item label="期次" prop="period" class="flex-form-item">
              <common-select ref="period" v-model="searchParam.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" clearable></common-select>
            </el-form-item>
            <el-form-item label="排序人" prop="configWkNo" class="flex-form-item">
              <selecter v-model="searchParam.configWkNo"></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportWorkscore">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'CreateOrUpdate')">
              <el-button type="downloadTemplate" style="width: 110px!important;" @click="factorMng">内置因素管理</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="declareRemind">提交提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="approvalRemind">审批提醒</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table"
          :seq-config="{ seqMethod }"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="160" title="姓名">
            <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="configWkInfo" title="排序人" width="150">
            <template #default="{ row }">
              <span>{{row.configWkName? row.configWkName + "("+row.configWkNo+")": row.configWkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
                <span v-if="row.isRatingCurnt">是</span>
                <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="noRatingReason" title="不参评原因" width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.noRatingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总分" width="80"></vxe-table-column>
          <vxe-table-column field="sort" title="排名" width="80"></vxe-table-column>
          <vxe-table-column field="remark" width="150" title="备注">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="95" fixed="right">
            <template #default="{ row }">
              <span class="name-col" @click="showImportancePage(row)">{{ statusMap[row.status]}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
            <template #default="scope">
              <template>
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                  <i class='icon-editor' @click.stop="showImportancePage(scope.row)"></i>
                </el-tooltip>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :propData="dialogContent.data" :param="commonParams"></component>
      </template>
    </common-dialog>
    <common-dialog ref="exportDialog" title="期次范围选择" width="530px" showClose :appendBody="true">
      <template slot="content">
        <exportComponent :param="exportParams"></exportComponent>
      </template>
    </common-dialog>
    <common-dialog ref="factorDialog" title="内置因素管理" width="800px" showClose :appendBody="true">
      <template slot="content">
        <FactorManage :param="exportParams" />
      </template>
    </common-dialog>
  </div>
</template>
  <script>
    import _ from 'lodash';
    import {
      CLASSIFY_MAP,
      MANAGE_EDITDABLE_CLASSIFY,
      PERIODS,
      PERIOD_LIST,
      OEC_LEVEL,
      IMPORTANCE_STATE,
      WORK_SCORE,
      YEAR_PLAN_STATUS
    } from '@/utils/period-enum.js';
    import periodMixin from '@/mixins/period.mixin';

    export default {
      name: "importanceSortManage",
      components: {
        selecter: () => import('@/component/global/customerSelect'),
        importanceSort: () => import('../manage/importanceSort'),
        exportComponent:() => import('./export.vue'),
        FactorManage:() => import('./FactorManage.vue'),
        CommitRemind: () => import('./CommitRemind.vue'),
        ApprovalRemind: () => import('./ApprovalRemind.vue'),
      },
      inject: ['reload'],
      mixins: [periodMixin],
      data() {
        return {
          that: this,
          currentPath: this.$route.path,
          oecStatusList: [
            { "itemValue": "0,10", "itemDesc": "未填报" },
            { "itemValue": "20", "itemDesc": "已填报" },
            { "itemValue": "30", "itemDesc": "已审批" },
            { "itemValue": "40", "itemDesc": "已公示" }
          ],
          classifyMap: CLASSIFY_MAP,
          editableClassify: MANAGE_EDITDABLE_CLASSIFY,
          workscoreStatusMap: WORK_SCORE,
          yearStatusMap: YEAR_PLAN_STATUS,
          periods: PERIODS,
          periodList: PERIOD_LIST,
          oecLevel: OEC_LEVEL,
          searchParam: {
            wkNo: '',
            wkName: '',
            superiorNo: '',
            year: undefined,
            period: undefined
          },
          page: {
            pageIndex: 1,
            pageSize: 10
          },
          total: 0,
          tableData: [],
          warnNum: 'warn-num',
          nomalNum: 'num',
          statusMap: IMPORTANCE_STATE,
          errMap: 1,
          currWkNo: '',
          wkNo: '',
          msgId: '',
          role: 1,
          monthColumns: [
            {field: 'm1', title: '1月',  width: 35, fixed: 'right'},
            {field: 'm2', title: '2月',  width: 35, fixed: 'right'},
            {field: 'm3', title: '3月',  width: 35, fixed: 'right'},
            {field: 'm4', title: '4月',  width: 35, fixed: 'right'},
            {field: 'm5', title: '5月',  width: 35, fixed: 'right'},
            {field: 'm6', title: '6月',  width: 35, fixed: 'right'},
            {field: 'm7', title: '7月',  width: 35, fixed: 'right'},
            {field: 'm8', title: '8月',  width: 35, fixed: 'right'},
            {field: 'm9', title: '9月',  width: 35, fixed: 'right'},
            {field: 'm10', title: '10月',  width: 40, fixed: 'right'},
            {field: 'm11', title: '11月',  width: 40, fixed: 'right'},
            {field: 'm12', title: '12月',  width: 40, fixed: 'right'},
          ],
          classifyPrefix: 'classify',
          treeData: [],
          defaultProps: {
            children: 'children',
            label: 'label'
          },
          depList:[],
          checkId:"",
          department:'',
          copyTreeData:[],
          departmentNo:'',
          expandedData:[],
          dialogContent: {
            width: '80%',
            componentName: 'importanceSort',
            title: '重要度排序',
            data: {}
          },
          isShowEdit: false,
          editForm: {},
          editFormRules: {},

          commonParams: {},
        }
      },
      computed: {
        exportParams() {
          return {
            loginWkNo: this.currWkNo,
            ...this.searchParam,
            year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
            period: this.searchParam.period || undefined,
            departmentNo: this.departmentNo
          }
        }
      },
      created() {
        this.wkNo = this.$route.query.wkNo || '';
        this.msgId = this.$route.query.msgId || '';
        this.role = this.$route.query.role || 1;
      },
      mounted() {
        const userInfo = sessionStorage.getItem('userInfo');
        this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
        this.getList();
        this.getDep();
      },
      activated() {
        this.getList();
      },
      methods: {
        // 格式化序列号
        seqMethod({ rowIndex }) {
          return rowIndex + (this.page.pageIndex - 1) * this.page.pageSize + 1;
        },
        async getList(resetPage) {
          this.setValid(1);
          this.$refs['searchForm'].validate(async (valid, errors) => {
            if (valid) {
              if (resetPage) {
                this.page.pageIndex = 1;
              }
              if (this.wkNo) {
                this.currWkNo = this.wkNo;
              }
              let page = this.page;
              let param = Object.assign(
                { loginWkNo: this.currWkNo },
                this.searchParam,
                {
                  year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
                  period: this.searchParam.period || undefined,
                  departmentNo: this.departmentNo
                },
                page
              );
  
              await this.$ajax.post(this.$api.period.importanceSortManage.GetImportanceManageListAsync, param).then(async (res) => {
                let resList = res.data.rows || [];
                let tableDatas = [];
                resList.forEach(item => {
                  let rowData = {
                    ...item.importantSortEntity,
                    ...item
                  };
                  tableDatas.push(rowData);
                });
                this.tableData = tableDatas;
                this.total = res.data.total;
              });
            } else {
              if (errors) {
                for (const key in errors) {
                  this.$message.error(errors[key][0].message)
                }
              }
            }
            this.setValid(0);
          })
        },
      async getDep() {
        await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
            this.depList=res.data||[];     
              const obj ={};
              this.depList.forEach(v=>{
              const objClone=_.cloneDeep(obj);
              objClone.id= v.id,
              objClone.code= v.code,
              objClone.label= v.displayName
            if(v.parentId===null){
                this.expandedData.push(v.id);
                objClone.children= this.depList.filter(t=>t.parentId===v.id);
                this.generateMenu(objClone.children);
                this.treeData.push(objClone);
                this.copyTreeData=_.cloneDeep(this.treeData);
              }
            });
          });
        },
        generateMenu(chs){
          chs.forEach(v=>{
            v.label= v.displayName
            v.children = this.depList.filter(t=>t.parentId === v.id)
            this.generateMenu(v.children);
          });
        },
        handleCheckChange(){
          this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
          let code = [] , deptNmae = [];
          this.selectNode.forEach(t => {
            code.push(t.code);
            deptNmae.push(t.label);
          });
          this.departmentNo = code.join(",");
          this.department = deptNmae.join(",");
        },
        getSimpleCheckedNodes(store) {
          const checkedNodes = [];
          const traverse = function(node) {
            const childNodes = node.root ? node.root.childNodes : node.childNodes;
            childNodes.forEach(child => {
              if (child.checked) {
                checkedNodes.push(child.data);
              }
              if (child.indeterminate) {
                traverse(child);
              }
            });
          };
          traverse(store)
          return checkedNodes;
        },
        editClose() {
          this.getList();
        },    
        pageChange({currentPage}) {
          this.page.pageIndex = currentPage;
          this.getList();
        },
        toWorkscoreList(row) {
          this.$router.push({path: '/period/manage/workscoreList', query: { wkNo: row.wkNo }});
        },
  
        toWorkscorePage(row) {
          if (row.category === 'Month') {
            this.$router.push({path: '/period/manage/workscore', query: { id: row.workScoreInfo.id }});
          } else if (row.category === 'Year') {
            this.$router.push({path: '/period/manage/yearWorkscore', query: { id: row.yearScoreInfo.id }});
          }
        },
        // 导出
        exportWorkscore() {
          this.setValid(1);
          this.$refs['searchForm'].validate(async (valid, errors) => {
            if (valid) {
              this.$ajax.get(this.$api.period.importanceSortManage.ImportanceManageListExport, this.exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
                if (res.data.type == 'application/json') {
                  var reader = new FileReader();
                  reader.onload = () => {
                    var content = reader.result;//内容就在这里
                    let json = JSON.parse(content)
                    this.$message.error(json.message)
                  };
                  reader.readAsText(res.data);
                } else {
                  const filename = '重要度排序管理'
                  const filetype = 'xlsx'
                  let data = res.data;
                  let url = window.URL.createObjectURL(data)
                  let a = document.createElement('a')
                  document.body.appendChild(a)
                  a.href = url
                  a.download = filename + '.' + filetype
                  a.click()
                  window.URL.revokeObjectURL(url)
                }
              });
            } else {
              if (errors) {
                for (const key in errors) {
                  this.$message.error(errors[key][0].message)
                }
              }
            }
            this.setValid(0);
          })
        },
        exportMulti(){
          this.$refs.exportDialog.show();
        },
        // 打开重要度排序弹窗
        showImportancePage(row) {
          this.dialogContent.data = row;
          this.$refs.commonDialog.show();
        },
        exportTask() {
          this.$refs['searchForm'].validate((valid) => {
            if (valid) {
              let queryWhere = _.cloneDeep(this.searchParam);
              queryWhere = {
                ...queryWhere,
                loginWkNo: this.currWkNo,
                year: queryWhere.year ? parseInt(queryWhere.year) : undefined,
                period: queryWhere.period || undefined,
                departmentNo: this.departmentNo
              };
              this.$ajax
                .get(this.$api.period.manage.taskExport, queryWhere)
                .then((res) => {
                  if (res.code === 0) {
                    this.$router.push({
                      path: '/manage/export-task/index',
                    });
                  }
                })
                .catch(() => {});
            }
          })
        },
        exportImportant() {
          this.$refs['searchForm'].validate(async (valid) => {
            if (valid) {
              this.$ajax.post(this.$api.period.manage.importantSortExport, this.exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
                if (res.data.type == 'application/json') {
                  var reader = new FileReader();
                  reader.onload = () => {
                    var content = reader.result;//内容就在这里
                    let json = JSON.parse(content)
                    this.$message.error(json.message)
                  };
                  reader.readAsText(res.data);
                } else {
                  const filename = '重要度排序'
                  const filetype = 'xlsx'
                  let data = res.data;
                  let url = window.URL.createObjectURL(data)
                  let a = document.createElement('a')
                  document.body.appendChild(a)
                  a.href = url
                  a.download = filename + '.' + filetype
                  a.click()
                  window.URL.revokeObjectURL(url)
                }
              });
            }
          })
        },
        expandRow({row, triggerTreeNode}) {
          if (triggerTreeNode) return;
          row.expandRowFlag = !row.expandRowFlag;
          let $table = this.$refs.table;
          $table.updateData(this.tableData);
        },
        factorMng() {
          this.$refs.factorDialog.show();
        },
        getYearPeriod() {
          let year = this.searchParam.year ? parseInt(this.searchParam.year) : undefined;
          let period = this.searchParam.period || undefined;
          if (!year && !period && this.tableData.length > 0) {
            const firstRow = this.tableData[0] || {};
            year = firstRow.year;
            period = firstRow.period;
          }
          return {year, period};
        },
        declareRemind() {
          const {year, period} = this.getYearPeriod();
          this.commonParams = {
            ...this.page,
            ...this.searchParam,
            departmentNo: this.departmentNo,
            year,
            period,
          };
          this.dialogContent = {
            title: '提醒人员确认',
            componentName: 'CommitRemind',
            width: '720px'
          }
          this.$refs.commonDialog.show()
        },
        approvalRemind() {
          const {year, period} = this.getYearPeriod();
          this.commonParams = {
            ...this.page,
            ...this.searchParam,
            departmentNo: this.departmentNo,
            year,
            period,
          };
          this.dialogContent = {
            title: '提醒人员确认',
            componentName: 'ApprovalRemind',
            width: '720px'
          }
          this.$refs.commonDialog.show()
        },
      },
      watch: {
        $route() {
          if (this.$route.path === this.currentPath) {
            this.reload();
          }
        },
        department: {
          handler(val){
            if(!val){
              this.departmentNo = "";
              this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
            }
          },
          immediate:true
        }
      },
    }
  </script>
  <style scoped lang='scss'>
    .content-page {
      height: 100%;
      .search-wrap {
        .atb-input {
          display: flex;
          flex-direction: column;
          .query-where {
            display: flex;
            flex-wrap: wrap;
            .flex-form-item {
              display: flex;
            }
            ::v-deep.el-form-item__content {
              flex: 1;
              .el-select, .el-autocomplete, .el-date-editor {
                width: 100%;
              }
            }
          }
          .query-operation {
            display: flex;
            flex-wrap: wrap;
            .flex-form-item {
              display: flex;
              flex: 1;
              max-width: 300px;
            }
            ::v-deep.el-form-item__label {
              white-space: nowrap;
            }
            ::v-deep.el-form-item__content{
              flex: 1;
              .el-select, .el-autocomplete, .el-date-editor {
                width: 100%;
              }
              .el-date-editor {
                min-width: 120px;
              }
              .el-select {
                min-width: 80px;
              }
            }
          }
        }
      }
      .table-content {
        position: relative;
      }
      .atb-content-bg {
        padding: 20px;
        flex: 1;
      }
      ::v-deep .tab {
        margin-top: -3px;
      }
      ::v-deep .el-dialog__body {
        padding-top: 33px !important;
        text-align: center;
        h2 {
          font-size: 18px;
          color: $--color-text-primary;
          font-weight: bold;
          margin-bottom: 10px;
        }
        p {
          color: $--color-text-regular;
        }
      }
      ::v-deep .el-dialog__footer {
        text-align: center;
      }
      .summary {
        margin-bottom: 20px;
        font-size: 14px;
        color: #4a5150;
        .item-data {
          margin-right: 40px;
          .cursor{
            cursor: pointer;
          }
          .num {
            font-weight: bolder;
            color: #22b6a1;
            padding: 10px;
          }
          .warn-num {
            font-weight: bolder;
            color: #fe6562;
            padding: 10px;
          }
        }
      }
    }
    .name-col {
      cursor: pointer;
      color: $--color-primary;
    }
    .collapse {
      margin-top: -15px;
      position: absolute;
      top: 50%;
      right: 0;
      width: 15px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: rgba(#000, 0.1);
      z-index: 99;
      cursor: pointer;
      &:hover {
        background-color: rgba(#000, 0.2);
      }
      i {
        font-size: 14px;
        color: #fff;
      }
    }
    .table-tabs {
      .table-tab {
        display: inline-block;
        margin: 8px;
        padding: 8px 10px;
        border-radius: 20px;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid $--color-primary;
        background-color: #d8f5f1;
        color: $--color-primary;
        &:hover, &.table-tab--active {
          background-color: $--color-primary;
          color: #fff;
        }
      }
      
    }
    .el-form-item.multi-line {
      ::v-deep .el-form-item__content {
        line-height: inherit;
      }
      .el-button.el-button--export, .el-button.el-button--downloadTemplate {
        width: 95px!important;
        white-space: normal;
        padding: 5px 2px;
        min-height: 40px;
      }
    }
    .el-dialog.changeDialog{
      .content{
        height: 500px;
        overflow: auto;
        .el-date-editor, .el-autocomplete{
          width: 100%;
        }
      }
      .el-select{
        width: 100%;
      }
      .write-summary{
        height: 150px;
      }
    }
  </style>